import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { console_ } from '../services/api';
import { dateFr, dateHeureFr, n } from '../services/format';
import { Erreur, Chargement, Vide, messageErreur } from './Ui';

const ETATS_CAMPAGNE = { brouillon: 'Brouillon', active: 'Active', suspendue: 'Suspendue', terminee: 'Terminée' };

// Campagnes de recueil / renouvellement : liste, création (admin), suivi,
// exécution manuelle d'un lot (le cron quotidien fait le reste).
export default function Campagnes({ user }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const admin = user.role === 'admin';
  const [liste, setListe] = useState(null);
  const [config, setConfig] = useState(null);
  const [erreur, setErreur] = useState('');
  const [creation, setCreation] = useState(false);

  const charger = () => console_.campagnes().then((r) => setListe(r.data)).catch((e) => setErreur(messageErreur(e)));
  useEffect(() => { charger(); console_.config().then((r) => setConfig(r.data)).catch(() => {}); }, []);

  if (id) return <Detail id={id} admin={admin} retour={() => { navigate('/campagnes'); charger(); }} />;

  return (
    <div>
      <h1 className="rg-titre-page">Campagnes</h1>
      <Erreur message={erreur} />
      {admin && config && (
        <div className="rg-actions" style={{ marginBottom: 16 }}>
          <button className="rg-btn rg-btn--principal" onClick={() => setCreation(!creation)}>{creation ? 'Fermer' : '+ Nouvelle campagne'}</button>
        </div>
      )}
      {creation && config && <Creation config={config} onCree={(c) => { setCreation(false); navigate(`/campagnes/${c.id}`); }} onErreur={(e) => setErreur(messageErreur(e))} />}
      {!liste ? <Chargement /> : liste.length === 0 ? <Vide>Aucune campagne. Une campagne cible les clients d'une société sans réponse connue et leur envoie le formulaire par SMS (ou e-mail), dans la limite d'un quota par jour.</Vide> : (
        <div className="rg-defile">
          <table className="rg-tableau">
            <thead><tr><th>Nom</th><th>Société</th><th>Finalités</th><th>Canal</th><th>Mode</th><th>État</th><th className="rg-num">Envoyées</th><th className="rg-num">Réponses</th><th className="rg-num">Erreurs</th><th>Créée</th></tr></thead>
            <tbody>
              {liste.map((c) => (
                <tr key={c.id} className="cliquable" onClick={() => navigate(`/campagnes/${c.id}`)}>
                  <td><strong>{c.nom}</strong></td>
                  <td>{c.raison_sociale}</td>
                  <td>{c.finalites.map((f) => f.replace('prospection_', '')).join(', ')}</td>
                  <td>{c.canal}</td>
                  <td>{c.mode}</td>
                  <td>{ETATS_CAMPAGNE[c.etat] || c.etat}</td>
                  <td className="rg-num">{n(c.envoyees)}</td>
                  <td className="rg-num">{n(c.repondues)}</td>
                  <td className="rg-num">{n(c.erreurs)}</td>
                  <td>{dateFr(c.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function Creation({ config, onCree, onErreur }) {
  const societes = config.societes.filter((s) => s.actif);
  const finalites = config.finalites.filter((f) => f.actif);
  const [f, setF] = useState({ nom: '', societe_id: societes[0]?.id || '', finalites: finalites.map((x) => x.code), canal: 'sms', mode: 'simulation', quota_jour: 200, relation_depuis_mois: 36, relations: [], expirant_jours: '', modele: '' });
  const maj = (k, v) => setF({ ...f, [k]: v });
  const basculer = (k, c) => maj(k, f[k].includes(c) ? f[k].filter((x) => x !== c) : [...f[k], c]);
  const valider = async (e) => {
    e.preventDefault();
    const cible = { relation_depuis_mois: Number(f.relation_depuis_mois) || undefined, relations: f.relations.length ? f.relations : undefined, expirant_jours: f.expirant_jours ? Number(f.expirant_jours) : undefined };
    try {
      const r = await console_.creerCampagne({ nom: f.nom, societe_id: Number(f.societe_id), finalites: f.finalites, canal: f.canal, mode: f.mode, quota_jour: Number(f.quota_jour), cible, modele: f.modele || null });
      onCree(r.data);
    } catch (e2) { onErreur(e2); }
  };
  return (
    <form className="rg-bloc rg-form" style={{ marginBottom: 20 }} onSubmit={valider}>
      <h3>Nouvelle campagne</h3>
      <div className="rg-ligne">
        <label>Nom<input value={f.nom} onChange={(e) => maj('nom', e.target.value)} required /></label>
        <label>Société responsable<select value={f.societe_id} onChange={(e) => maj('societe_id', e.target.value)}>{societes.map((s) => <option key={s.id} value={s.id}>{s.raison_sociale}</option>)}</select></label>
      </div>
      <div className="rg-cases">{finalites.map((x) => <label key={x.code}><input type="checkbox" checked={f.finalites.includes(x.code)} onChange={() => basculer('finalites', x.code)} /> {x.code.replace('prospection_', '')}</label>)}</div>
      <div className="rg-ligne">
        <label>Canal<select value={f.canal} onChange={(e) => maj('canal', e.target.value)}><option value="sms">SMS</option><option value="email">E-mail</option></select></label>
        <label>Mode<select value={f.mode} onChange={(e) => maj('mode', e.target.value)}><option value="simulation">Simulation (rien n'est envoyé)</option><option value="actif">Actif</option></select></label>
        <label>Quota par jour<input type="number" min="1" value={f.quota_jour} onChange={(e) => maj('quota_jour', e.target.value)} /></label>
      </div>
      <div className="rg-ligne">
        <label>Relation depuis (mois)<input type="number" min="1" value={f.relation_depuis_mois} onChange={(e) => maj('relation_depuis_mois', e.target.value)} /></label>
        <label>Renouvellement : accords expirant sous (jours, vide = jamais demandés)<input type="number" min="1" value={f.expirant_jours} onChange={(e) => maj('expirant_jours', e.target.value)} /></label>
      </div>
      <div className="rg-cases">Types de relation : {['atelier', 'vn', 'vo', 'contrat'].map((r) => <label key={r}><input type="checkbox" checked={f.relations.includes(r)} onChange={() => basculer('relations', r)} /> {r}</label>)}<span className="rg-info">(aucun coché = tous)</span></div>
      <label>Modèle de message (vide = modèle par défaut ; variables {'{societe}'}, {'{lien}'}, {'{prenom}'})<textarea value={f.modele} onChange={(e) => maj('modele', e.target.value)} placeholder={config.modele_sms} /></label>
      <div className="rg-actions"><button className="rg-btn rg-btn--principal" disabled={!f.nom || !f.finalites.length}>Créer en brouillon</button></div>
    </form>
  );
}

function Detail({ id, admin, retour }) {
  const [c, setC] = useState(null);
  const [cible, setCible] = useState(null);
  const [erreur, setErreur] = useState('');
  const [message, setMessage] = useState('');
  const [max, setMax] = useState(50);
  const charger = () => Promise.all([console_.campagne(id), console_.cibleCampagne(id)])
    .then(([a, b]) => { setC(a.data); setCible(b.data); })
    .catch((e) => setErreur(messageErreur(e)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { charger(); }, [id]);

  const changerEtat = async (etat) => {
    try { await console_.modifierCampagne(id, { etat }); setMessage(`Campagne ${ETATS_CAMPAGNE[etat].toLowerCase()}.`); charger(); } catch (e) { setErreur(messageErreur(e)); }
  };
  const lancer = async () => {
    try {
      const r = (await console_.lancerCampagne(id, Number(max) || null)).data;
      setMessage(`Lot exécuté : ${r.envoyees} envoyée${r.envoyees > 1 ? 's' : ''}, ${r.erreurs} erreur${r.erreurs > 1 ? 's' : ''}${r.quota_atteint ? ', quota du jour atteint' : ''}${r.terminee ? ', campagne terminée (plus de cible)' : ''}.`);
      charger();
    } catch (e) { setErreur(messageErreur(e)); }
  };

  if (erreur && !c) return <Erreur message={erreur} />;
  if (!c) return <Chargement />;
  const stat = (s) => Number((c.stats.find((x) => x.statut === s) || {}).n || 0);
  return (
    <div>
      <button className="rg-btn" onClick={retour} style={{ marginBottom: 12 }}>← Campagnes</button>
      <h1 className="rg-titre-page">{c.nom}</h1>
      {message && <div className="rg-succes">{message}</div>}
      <Erreur message={erreur} />
      <div className="rg-cartes">
        <Carte label="État" valeur={ETATS_CAMPAGNE[c.etat] || c.etat} sous={`${c.mode} · ${c.canal}`} />
        <Carte label="Cible restante" valeur={cible ? n(cible.restants) : '…'} sous={`quota ${n(c.quota_jour)} / jour`} />
        <Carte label="Envoyées" valeur={n(stat('envoyee') + stat('ouverte') + stat('repondue') + stat('expiree'))} sous={`${n(stat('erreur'))} en erreur`} />
        <Carte label="Répondues" valeur={n(stat('repondue'))} sous={`${n(stat('ouverte'))} ouvertes sans réponse`} />
      </div>
      <div className="rg-grille">
        <div className="rg-bloc">
          <h3>Paramètres</h3>
          <dl>
            <dt>Société</dt><dd>{c.raison_sociale}</dd>
            <dt>Finalités</dt><dd>{c.finalites.join(', ')}</dd>
            <dt>Cible</dt><dd className="rg-mono">{JSON.stringify(c.cible)}</dd>
            <dt>Modèle</dt><dd>{c.modele || <span className="rg-info">modèle par défaut</span>}</dd>
            <dt>Créée</dt><dd>{dateHeureFr(c.created_at)} par {c.cree_par}</dd>
          </dl>
          {admin && (
            <div className="rg-actions">
              {c.etat !== 'active' && c.etat !== 'terminee' && <button className="rg-btn rg-btn--principal" onClick={() => changerEtat('active')}>Activer</button>}
              {c.etat === 'active' && <button className="rg-btn" onClick={() => changerEtat('suspendue')}>Suspendre</button>}
              {c.etat !== 'terminee' && <button className="rg-btn rg-btn--danger" onClick={() => changerEtat('terminee')}>Terminer</button>}
            </div>
          )}
          {admin && c.etat === 'active' && (
            <div className="rg-actions" style={{ alignItems: 'center' }}>
              <input type="number" min="1" value={max} onChange={(e) => setMax(e.target.value)} style={{ width: 80, padding: 6 }} aria-label="Nombre maximal" />
              <button className="rg-btn rg-btn--principal" onClick={lancer}>Lancer un lot maintenant</button>
              <span className="rg-info">Le cron quotidien (07:30) envoie le reste dans la limite du quota.</span>
            </div>
          )}
        </div>
        <div className="rg-bloc">
          <h3>Réponses par finalité</h3>
          {c.reponses.length === 0 ? <p className="rg-info">Aucune réponse pour l'instant.</p> : (
            <table className="rg-tableau">
              <thead><tr><th>Finalité</th><th>État</th><th className="rg-num">N</th></tr></thead>
              <tbody>{c.reponses.map((r, i) => <tr key={i}><td>{r.finalite_code}</td><td>{r.etat}</td><td className="rg-num">{n(r.n)}</td></tr>)}</tbody>
            </table>
          )}
          <h3 style={{ marginTop: 16 }}>Envois par jour</h3>
          {c.jours.length === 0 ? <p className="rg-info">Aucun envoi.</p> : (
            <table className="rg-tableau">
              <tbody>{c.jours.map((j) => <tr key={j.jour}><td>{dateFr(j.jour)}</td><td className="rg-num">{n(j.n)}</td></tr>)}</tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

function Carte({ label, valeur, sous }) {
  return <div className="rg-carte"><div className="rg-carte-label">{label}</div><div className="rg-carte-valeur">{valeur}</div>{sous && <div className="rg-carte-sous">{sous}</div>}</div>;
}
